export const PROCESSING_BLOCK_ADD = "PROCESSING_BLOCK_ADD";
export const PROCESSING_BLOCK_REMOVE = "PROCESSING_BLOCK_REMOVE";
export const RELATED_POSTS_UPDATE = "RELATED_POSTS_UPDATE";
